import React from "react";
import "./FooterSection.css";

const Footer = () => {
  return (
    <div className="footer-wrapper">
      <h2 className="footer">Thank you for visiting my portfolio!</h2>
      <h1 className="footerSubtext">
        Designed and developed by Abhishek HM © 2025.
      </h1>
    </div>
  );
};

export default Footer;
